import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import { FaStar, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { FcGoogle } from 'react-icons/fc';
import { MdVerified } from 'react-icons/md';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import './testimonial.css';

const testimonials = [
  {
    id: 1,
    name: 'Bhumika Ashvinikumar Sharma',
    time: '1 year ago',
    avatar: 'https://i.pravatar.cc/150?img=47',
    rating: 5,
    text: 'My son is registered with castyou and has been featured for the brand Kurata, and amazon we really loved the shoot and looking forward for more such...',
  },
  {
    id: 2,
    name: 'Shirin Khan',
    time: '1 year ago',
    avatar: 'https://i.pravatar.cc/150?img=12',
    rating: 5,
    text: "Castyou Casting Agency, with Jhanvi's help at the helm, has exceeded all expectations. Their professionalism, attention to detail, and commitment to...",
  },
  {
    id: 3,
    name: 'Hiral Bariya',
    time: '1 year ago',
    avatar: 'https://i.pravatar.cc/150?img=32',
    rating: 5,
    text: 'The best thing about Miss Jidnysa is that she is very helpful and personally sees that his client should not face any problem in any shooting. She also puts i...',
  },
  {
    id: 4,
    name: 'Rahul Verma',
    time: '8 months ago',
    avatar: 'https://i.pravatar.cc/150?img=59',
    rating: 5,
    text: 'Great experience collaborating with the team! The audition process was smooth, professional, and well coordinated throughout.',
  },
];

function Testimonial() {
  return (
    <section className="testimonial-section">
      <h2 className="testimonial-title">WHAT PEOPLE SAY ABOUT US ON GOOGLE</h2>

      <div className="slider-wrapper">
        {/* Navigation Buttons */}
        <button className="nav-btn prev-btn" aria-label="Previous">
          <FaChevronLeft />
        </button>
        <button className="nav-btn next-btn" aria-label="Next">
          <FaChevronRight />
        </button>

        <Swiper
          modules={[Navigation, Autoplay]}
          navigation={{
            prevEl: '.prev-btn',
            nextEl: '.next-btn',
          }}
          autoplay={{ delay: 4000, disableOnInteraction: false }}
          spaceBetween={24}
          slidesPerView={1}
          breakpoints={{
            640: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
        >
          {testimonials.map((item) => (
            <SwiperSlide key={item.id}>
              <div className="card-container">
                {/* Floating Avatar + Google Badge */}
                <div className="avatar-wrapper">
                  <img src={item.avatar} alt={item.name} className="avatar-img" />
                  <span className="google-badge">
                    <FcGoogle size={18} />
                  </span>
                </div>

                {/* Card Content */}
                <div className="card-body">
                  <h3 className="user-name">{item.name}</h3>
                  <span className="user-time">{item.time}</span>

                  <div className="rating-row">
                    <div className="stars">
                      {[...Array(item.rating)].map((_, i) => (
                        <FaStar key={i} />
                      ))}
                    </div>
                    <MdVerified className="verified-icon" />
                  </div>

                  <p className="user-review">{item.text}</p>
                  <button className="read-more-btn">Read more</button>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}

export default Testimonial;